import { useState, useEffect } from 'react';
import { fetchGraphql } from '../services/strapi';

function mapResponse({data}: apiResponse): response {
  return {
    blogs: data.blogs.data.map(({id, attributes}) => {return {
      id: id,
      title: attributes.title,
      description: attributes.description,
      body: attributes.body,
      author: attributes.author,
      img: attributes.link_img,
      date: attributes.date,
      index: attributes.index,
    }}),
    normas: {
      total: data.normas.meta.pagination.total
    },
    decisions: {
      total: data.decisions.meta.pagination.total
    },
    dissertations: {
      total: data.dissertations.meta.pagination.total
    },
    publications: {
      total: data.publications.meta.pagination.total
    }
  };
}

type apiResponse = {
  data: {
    blogs: {
      data: {
        id: string,
        attributes: {
          title: string,
          description: string,
          body: string,
          author: string,
          link_img: string,
          date: string,
          index: string
        }
      }[]
    },
    normas: {
      meta: {
        pagination: {
          total: number
        }
      }
    },
    decisions: {
      meta: {
        pagination: {
          total: number
        }
      }
    },
    dissertations: {
      meta: {
        pagination: {
          total: number
        }
      }
    },
    publications: {
      meta: {
        pagination: {
          total: number
        }
      }
    }
	}
}

export type response = {
  blogs: {
    id: string,
    title: string,
    description: string,
    body: string,
    author: string,
    img: string,
    date: string,
    index: string
  }[],
  normas: {
    total: number
  },
  decisions: {
    total: number
  },
  dissertations: {
    total: number
  },
  publications: {
    total: number
  },
};


export function useHomeObjects(): response {
  const initialData: response = {
    blogs: [],
    normas: {
      total: 0
    },
    decisions: {
      total: 0
    },
    dissertations: {
      total: 0
    },
    publications: {
      total: 0
    },
  }
  const [data, setData] = useState<response>(initialData);
  
  async function fetchData() {
    setData(await getEvents());
  }

  useEffect(() => {
    fetchData();
  }, [data.blogs.length, data.normas.total, data.decisions.total, data.dissertations.total]);

  return data;
};


export async function getEvents(): Promise<response> {
  let query: string = `
  query {
    blogs(
      sort: ["date:desc", "important:desc", "createdAt:desc"], 
      pagination: {start: 0, limit: 3}
    ) {
      data {
        id,
        attributes {
          title,
          description,
          body,
          author,
          link_img,
          date,
          index
        }
      }
    },
    normas {
      meta {
        pagination {
          total
        }
      }
    },
    decisions {
      meta {
        pagination {
          total
        }
      }
    },
    dissertations {
      meta {
        pagination {
          total
        }
      }
    },
    publications {
      meta {
        pagination {
          total
        }
      }
    }
  }
  `;
  
  return await makeRequest(query);
}


async function makeRequest(query: string): Promise<response> {
  const response: apiResponse = await fetchGraphql({query: query});
    return mapResponse(response);
}